import { AuthService } from './auth.service';
import { BaseConfig } from './models/config.model';

export class KeycloakAdapter {
  public get token(): string {
    return this.authService.accessToken;
  }

  public get realm(): string {
    return this.baseConfig.keycloakConfig.realm;
  }

  public get clientId(): string {
    return this.baseConfig.authConfig.clientId;
  }

  public get authServerUrl(): string {
    return this.baseConfig.keycloakConfig.authServerUrl;
  }

  public get resourceServerId(): string {
    return this.baseConfig.keycloakConfig.resourceServerId;
  }

  constructor(
    private authService: AuthService,
    private baseConfig: BaseConfig,
  ) {}
}
